/**
 * 课程管理
 */
export default {
  /* 课程分类 */
  getCategoryList: "/courseCategory/list",  // 列表
  getCategoryListSelect: "/courseCategory/categoryList",  // 分类下拉
  newAddCategory: "/courseCategory/newAdd",  // 新增
  newUpdateCategory: "/courseCategory/newUpdate",  // 修改
  newDeleteCategory: "/courseCategory/newDelete",  // 删除

  /* 课程列表 */
  selectCourseInfoPage: "/courseInfo/selectCourseInfoPage",  // 列表
  insertCourseInfo: "/courseInfo/insertCourseInfo",  // 新增
  updateCourseInfo: "/courseInfo/updateCourseInfo",  // 修改
  selectCourseInfoDetail: "/courseInfo/selectCourseInfoDetail",  // 详情
  deleteCourseInfo: "/courseInfo/deleteCourseInfo",  // 删除
  updateRecommendFlag: "/courseInfo/updateRecommendFlag",  // 修改是否推荐
  selectListByTeacher: "/teacherInfo/selectList",  // 教师下拉
  updateOnlineStatusCourse: "/courseInfo/updateOnlineStatus",  // 上下架
  updateVirtualCount: "/courseInfo/updateVirtualCount",  // 修改虚拟在学人数
  selectUserBuyPage: "/courseInfo/selectUserBuyPage",  // 已购用户列表

  /* 课时管理 */
  selectCourseLessonPage: "/courseLesson/selectCourseLessonPage",  // 列表
  insertCourseLesson: "/courseLesson/insertCourseLesson",  // 新增
  updateCourseLesson: "/courseLesson/updateCourseLesson",  // 修改
  deleteCourseLesson: "/courseLesson/deleteCourseLesson",  // 删除
  updateOnlineStatusLesson: "/courseLesson/updateOnlineStatus",  // 上下架

  selectQuestionInfoPage: "/question/selectQuestionInfoPage",  // 列表
  insertQuestionInfo: "/question/insertQuestionInfo",  // 新增
  updateQuestionInfo: "/question/updateQuestionInfo",  // 修改
  deleteQuestionInfo: "/question/deleteQuestionInfo",  // 删除
  importQuestionInfo: "/question/importQuestionInfo",  // 导入
}
